import _ from 'lodash';

const YOUTUBE_PATTERNS = [
  () => /https:\/\/www\.youtube\.com\/embed\/([a-z\-_\d]+)/gi,
  () => /https:\/\/www\.youtube\.com\/watch\?v=([a-z\-_\d]+)/gi,
  () => /https:\/\/m\.youtube\.com\/watch\?v=([a-z\-_\d]+)/gi,
  () => /https:\/\/youtu\.be\/([a-z\-_\d]+)/gi,
];
const VIMEO_PATTERNS = [() => /https:\/\/vimeo\.com\/(\d+)/gi, () => /https:\/\/player\.vimeo\.com\/video\/(\d+)/gi];

const _isSupported = (patterns, url) => {
  let result = false;
  patterns.map(fn => fn()).forEach(pattern => {
    result = result || Boolean(pattern.exec(url));
  });
  return result;
};

const extractVideoId = (patterns, url) => {
  let result;
  patterns.map(fn => fn()).forEach(pattern => {
    const matches = pattern.exec(url);
    if (matches) {
      result = matches[1];
    }
  });
  return result;
};

const PROVIDERS = [
  {
    isSupported: url => _isSupported(YOUTUBE_PATTERNS, url),
    buildEmbedUrl: url => {
      const videoId = extractVideoId(YOUTUBE_PATTERNS, url);
      return `https://www.youtube.com/embed/${videoId}?enablejsapi=1`;
    },
    buildUrl: url => {
      const videoId = extractVideoId(YOUTUBE_PATTERNS, url);
      return `https://youtu.be/${videoId}`;
    },
  },
  {
    isSupported: url => _isSupported(VIMEO_PATTERNS, url),
    buildEmbedUrl: url => {
      const videoId = extractVideoId(VIMEO_PATTERNS, url);
      return `https://player.vimeo.com/video/${videoId}?api=1`;
    },
    buildUrl: url => {
      const videoId = extractVideoId(VIMEO_PATTERNS, url);
      return `https://vimeo.com/${videoId}`;
    },
  },
];

export const getProvider = url => {
  return _.find(PROVIDERS, provider => provider.isSupported(url));
};

export const isSupported = url => {
  return _.some(PROVIDERS, provider => provider.isSupported(url));
};

export const buildEmbedUrl = url => _.invoke(getProvider(url), 'buildEmbedUrl', url);

export const buildUrl = url => _.invoke(getProvider(url), 'buildUrl', url);



// WEBPACK FOOTER //
// ./app/services/video-embed.js